import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Title = ({ listBottom }) => {
    return (
        <div className="otpBank-title">
            <FullWrapper>
                <div className="otpBank-titleWrapper">
                    <div className="otpBank-titleLeft">
                        <h1 className="otpBank-titleLeftHeader">
                            Узкие ключи и&nbsp;контентное SEO: кейс&nbsp;ОТП&nbsp;Банка
                        </h1>
                        <div className="otpBank-titleLeftMiddle">
                            В&nbsp;этом кейсе расскажем, как с&nbsp;помощью SEO за&nbsp;один год
                            сотрудничества с&nbsp;ОТП Банком добились высоких позиций в&nbsp;выдаче
                            по&nbsp;ключевым запросам, увеличили поисковой трафик и&nbsp;общую
                            видимость сайта.
                        </div>

                        <div className="otpBank-titleLeftBottom">
                            {listBottom.map((item, index) => (
                                <div className="otpBank-titleLeftBottomList" key={index}>
                                    <div className="otpBank-titleLeftBottomName">{item.name}</div>
                                    <div className="otpBank-titleLeftBottomDescription">
                                        {item.description}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="otpBank-titleLeftFooter">
                            <div className="otpBank-titleLeftFooterTitle">ОТП Банк</div>
                            <a
                                href="https://www.otpbank.ru/"
                                target="_blank"
                                className="otpBank-titleLeftFooterLink"
                                rel="noopener noreferrer nofollow"
                            >
                                otpbank.ru
                            </a>
                            <div className="otpBank-titleLeftFooterSubtitle">
                                ОТП Банк, входит в&nbsp;международную финансовую Группу
                                OTP&nbsp;Group. Основные направления деятельности: кредитование
                                физических и&nbsp;юридических лиц, инвестиционные продукты, услуги
                                для бизнеса и&nbsp;финансовых организаций.
                            </div>
                        </div>
                    </div>
                    <div className="otpBank-titleRight">
                        <img
                            src="/images/pic/otp-bank/otp-bank.jpg"
                            alt=""
                            className="otpBank-titleRightImage"
                        />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Title;
